import SessionConst from 'constants/SessionConst'

const sessionKeyPrefix = 'ehogStorage'

/**
 * Gets session param using key
 *
 * @param {String} key session key
 * @returns {String}
 */
export function getSessionItem(key) {
    try {
        return (
            JSON.parse(window.sessionStorage && window.sessionStorage.getItem(`${sessionKeyPrefix}-${key}`)) || ''
        );
    } catch (error) {
        return null;
    }
}

/**
 * Gets access token from session param
 *
 * @returns {String}
 */
export function getAccessTokenFromSession() {
    try {
        return (
            JSON.parse(window.sessionStorage && window.sessionStorage.getItem(SessionConst.ACCESS_TOKEN))?.accessToken?.accessToken || ''
        );
    } catch (error) {
        return null;
    }
}

/**
 * Returns whether session storage is available
 * @returns {Boolean}
 */
export function isSessionAvailable() {
    try {
        window.sessionStorage.setItem('testSessionStorage', 1);
        window.sessionStorage.removeItem('testSessionStorage');
    } catch (error) {
        return false;
    }
    return true;
}

/**
 * removes session key from storage
 * @param {String} key session key
 * @returns {*|Boolean} value or false if error
 */
export function removeSessionItem(key) {
    try {
        window.sessionStorage.removeItem(`${sessionKeyPrefix}-${key}`);
    } catch (error) {
        return false;
    }

    // Removing from ngSession as well so angular does not re-populate session
    if (window.$sessionStorage) {
        delete window.$sessionStorage[key];
    }

    return true;
}

/**
 * Sets session param to given value
 *
 * @param {String} key session key
 * @param {*} value
 * @returns {*|Boolean} value or false if error
 */
export function setSessionItem(key, value) {
    let stringedValue;
    switch (typeof value) {
        case 'string':
            stringedValue = `"${value}"`;
            break;
        case 'object':
        case 'number':
            stringedValue = JSON.stringify(value);
            break;
        default:
            return false;
    }

    try {
        window.sessionStorage.setItem(`${sessionKeyPrefix}-${key}`, stringedValue);
    } catch (error) {
        return false;
    }

    if (window.$sessionStorage) {
        window.$sessionStorage[key] = value;
    }

    return value;
}

export function clearSession() {
    try {
        window.sessionStorage.clear()
        window.localStorage.clear()
        return true
    } catch (error) {
        return false
    }
}